import { render, staticRenderFns } from "./SystemLog.vue?vue&type=template&id=4b48ac5e&scoped=true"
import script from "./SystemLog.vue?vue&type=script&lang=js"
export * from "./SystemLog.vue?vue&type=script&lang=js"
import style0 from "./SystemLog.vue?vue&type=style&index=0&id=4b48ac5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b48ac5e",
  null
  
)

export default component.exports